import React, { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Theme } from '@mui/material';

/* ************ Type ************ */
type StyleProps = {
  children?: React.ReactNode;
  className?: string;
  borderColor?: string;
};

// makeStylesでstyleを定義
const useStyles = makeStyles<StyleProps>()((theme, { borderColor }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: theme.palette.common.white,
    borderRadius: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
    borderWidth: '2px',
    borderStyle: 'solid',
    textTransform: 'none',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  defaultStyle: {
    width: '200px',
    height: '48px',
    fontSize: '19px',
    borderColor: borderColor ?? theme.palette.common.black,
  },
}));

/* ********** Main Component ********* */
const BorderBox: React.FC<React.PropsWithChildren<StyleProps>> = (props) => {
  const { children, className, borderColor } = props;
  const { classes } = useStyles({ borderColor });
  const styleClass = `${classes.root} ${className || classes.defaultStyle}`;

  return <Box className={styleClass}>{children}</Box>;
};

// レンダーが前回と変わらない場合前回のレンダーを再利用
export default memo(BorderBox);
